module.exports = __webpack_public_path__ + "static/media/20_000010.50cf499d.jpg";